import { Col, Row } from 'antd';
import React from 'react';

import KALogo from 'images/ka-logo-black.png';
import NavCategoryItem from '../../Atoms/NavCategoryItem';
import Styles from './NavItem.module.scss';

const NavItem: React.FC = () => {
  const onLogoKAClick = () => location.replace('/');
  const onSneakersClick = () => location.replace('/sneakers');
  const onApparelClick = () => location.replace('/apparel');
  const onLuxuryClick = () => location.replace('/luxury');
  const onToysClick = () => location.replace('/electronics-collectibles');
  return (
    <Col>
      <Row
        align="middle"
        justify="center"
        className={Styles['nav-container']}
        gutter={32}
      >
        <NavCategoryItem
          onClick={onSneakersClick}
          mode={'text'}
          title={'Sneakers'}
          selected={location.pathname.includes('/sneakers')}
        />
        <NavCategoryItem
          onClick={onApparelClick}
          mode={'text'}
          title={'Apparel'}
          selected={location.pathname.includes('/apparel')}
        />
        <NavCategoryItem
          onClick={onLogoKAClick}
          mode={'image'}
          image={KALogo}
        />
        <NavCategoryItem
          onClick={onLuxuryClick}
          mode={'text'}
          title={'Luxury'}
          selected={location.pathname.includes('/luxury')}
        />
        <NavCategoryItem
          mode={'text'}
          title={'Electronics & Collectibles'}
          onClick={onToysClick}
          selected={location.pathname.includes('/electronics-collectibles')}
        />
      </Row>
    </Col>
  );
};

export default NavItem;
